
<observation-bar-chart *ngIf="visualizationType == 'bar'" [observations]="observations"></observation-bar-chart>
<observation-table *ngIf="visualizationType == 'table'" [observations]="observations"></observation-table>
